import { CitiesChartProps } from './cities-chart.props';

export const CitiesChartPresets: Partial<CitiesChartProps> = {
  cities: [],
};
